var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "observerTarget" }, [
    _vm.data && _vm.data.length
      ? _c(
          "div",
          [
            _vm._l(_vm.data, function (review, index) {
              return _c("div", { key: review.id, staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-lg-3 mb-3 mb-lg-0 d-flex d-lg-block",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ms-auto ms-lg-0 me-lg-3 order-2 order-lg-1 mb-3",
                      },
                      [
                        review.rating === 10
                          ? _c(
                              "small",
                              {
                                staticClass:
                                  "badge rounded-pill text-success bg-success-subtle",
                              },
                              [
                                _c("span", { staticClass: "text-capitalize" }, [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("recommended"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("i", { staticClass: "fas fa-thumbs-up" }),
                              ]
                            )
                          : review.rating === 5
                          ? _c(
                              "small",
                              {
                                staticClass:
                                  "badge rounded-pill text-secondary bg-secondary-subtle",
                              },
                              [
                                _c("span", { staticClass: "text-capitalize" }, [
                                  _vm._v(
                                    _vm._s(_vm._f("translate")("neutral"))
                                  ),
                                ]),
                              ]
                            )
                          : review.rating === 0
                          ? _c(
                              "small",
                              {
                                staticClass:
                                  "badge rounded-pill text-secondary bg-secondary-subtle",
                              },
                              [
                                _c("span", { staticClass: "text-capitalize" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")("not recommended")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("i", { staticClass: "fas fa-thumbs-down" }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-1 order-lg-2" }, [
                      _c("div", {}, [
                        _vm._v(
                          "\n            " +
                            _vm._s(review.first_name) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-muted small" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.humanDate(review.created_at)) +
                            "\n          "
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-9" }, [
                  _c("figure", { staticClass: "m-0" }, [
                    _c(
                      "blockquote",
                      {
                        staticClass: "blockquote mb-2",
                        class: !review.review ? "text-muted fst-italic" : "",
                      },
                      [
                        _c("p", { staticClass: "small" }, [
                          review.review
                            ? _c("i", {
                                staticClass:
                                  "fas fa-quote-left me-2 text-warning",
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("translate")(
                                  review.review || "No descriptive opinion"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("figcaption", { staticClass: "blockquote-footer m-0" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-muted",
                          attrs: { href: `/${review.course.slug}` },
                        },
                        [_vm._v(_vm._s(review.title))]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  index !== _vm.data.length - 1
                    ? _c("hr", { staticClass: "my-5" })
                    : _vm._e(),
                ]),
              ])
            }),
            _vm._v(" "),
            _vm.next_page_url
              ? _c("div", { staticClass: "row mt-5" }, [
                  _c("div", { staticClass: "col text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm btn-outline-dark px-4 text-capitalize",
                        on: { click: _vm.loadMore },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("translate")("More")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        )
      : _vm.data && !_vm.data.length
      ? _c("div", { staticClass: "text-center" }, [
          _vm._v(
            "\n    " + _vm._s(_vm._f("translate")("No reviews yet")) + ". "
          ),
          _c("a", { staticClass: "text-dark", attrs: { href: "/login" } }, [
            _c("u", [
              _vm._v(
                _vm._s(
                  _vm._f("translate")(
                    "Log in to be the first to share your thoughts"
                  )
                ) + "!"
              ),
            ]),
          ]),
        ])
      : !_vm.data && !_vm.loaded
      ? _c(
          "div",
          [_c("Spinner", { staticClass: "d-flex align-items-center" })],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }